import {
  LocalizationProvider,
  LocalizationProviderProps,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { DayjsLocalizationProviderProps } from "./DayjsLocalizationProvider.types";

const DayjsLocalizationProvider = <TDate, TLocale>({
  children,
  ...innerProps
}: DayjsLocalizationProviderProps<TDate, TLocale>) => (
  <LocalizationProvider
    {...innerProps}
    dateAdapter={
      AdapterDayjs as unknown as LocalizationProviderProps<
        TDate,
        TLocale
      >["dateAdapter"]
    }
  >
    {children}
  </LocalizationProvider>
);

export default DayjsLocalizationProvider;
